export default __webpack_public_path__ + "static/media/app_demo.45a4f157.svg";